module.exports = __webpack_public_path__ + "img/wx.19b6588a.png";